import { useEffect } from 'react';
import AuthService from '../../services/authorization';
import LoadingScreen from '../LoadingScreen';

const LogoutRedirect = () => {
  const Auth = new AuthService();

  useEffect(() => {
    Auth.logout();
  }, []);

  return <LoadingScreen />;
};

export default LogoutRedirect;
